/*

----- Ellipsis ----- 
When the content is too longer to fix within a table cell ( for example ) allow the user to scroll the text by hovering.
*/

var instances = {};

// Instances get / set functions.
function setContext(id, value) {
    instances[id]['context'] = value;
    return instances[id]['context'];
}
function getContext(id) {
    return instances[id]['context'];
}
function setBreakpoint(id, value) {
    instances[id]['breakpoint'] = value;
    return instances[id]['breakpoint'];
}
function getBreakpoint(id) {
    return instances[id]['breakpoint'];
}

function initialiseAll() {
    // Get all elements.
    let elements = $('[' + expressSelectors()['ellipsis']['initialise'] + ']');
    // Loop through elements to initialise.
    elements.each(function() {
        // Grab context.
        let context = $(this);
        // Init
        let init = initialise(context);
    });

    // Add global listener for resizing, this may need to be changed out for the generic 'resize' event to increase sensitivity.
    $(window).on('changed.zf.mediaquery', function(event, newSize, oldSize) {
        // Loop through each instance.
        $.each(instances, function(key, value) {
            // Get instance id.
            let id = key;
            // Get context.
            let context = getContext(id);
            // Get breakpoint.
            let breakpoint = getBreakpoint(id);
            // If breakpoint defined then toggle depending on that.
            if (breakpoint) {
                if (Foundation.MediaQuery.is(breakpoint)) {
                    // If current breakpoint active.
                    toggleEllipsis(id);
                } else {
                    context.removeClass('ellipsis-active ellipsis-text');
                }
            } else {
                // If no breakpoint defined then just toggle ellipsis regardless.
                toggleEllipsis(id);
            }
        });
    });
}

function initialise(context) {
    // Get instance id.
    let id = context.attr(expressSelectors()['ellipsis']['initialise']);
    // If no Id then generate one.
    if (!id) {
        context.attr(expressSelectors()['ellipsis']['initialise'], generateId());
        id = context.attr(expressSelectors()['ellipsis']['initialise']);
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Sticky: Instance already initialised skipping.");
        }
        return false;
    }

    // Get config.
    // Optional on what breakpoint(s) should this work.
    let breakpoint = context.attr(expressSelectors()['ellipsis']['breakpoint']);
    // Fallback.
    if (breakpoint == undefined) {
        // Check parents if attribute has been defined on them instead on context itself.
        breakpoint = context.parents('[' + expressSelectors()['ellipsis']['breakpoint'] + ']').attr(expressSelectors()['ellipsis']['breakpoint']);
    }

    // Update instance.
    setContext(id, context);
    setBreakpoint(id, breakpoint);

    context.parent().css('position', 'relative');

    // Assign classes
    toggleEllipsis(id);

    // TODO: check table-layout is fixed.
}

function isOverflowing(id) {
    // Get context.
    let context = getContext(id);
    // Width of context content including hidden content ( scrollable area ).
    let contentWidth = context.prop('scrollWidth');
    // Visual context width.
    let availableWidth = 0
    // Get column context.
    let columnContext = context.closest('td');
    // If in table.
    if (columnContext.length) {
        // Get interal width excluding padding.
        availableWidth = columnContext.width();
        // Round up as browser rounds clientWidth, scrollWidth, offsetWidth to nearest integrer.
        availableWidth =  Math.round(availableWidth);
    } else {
        availableWidth = context.prop('offsetWidth');
    }
    // Is the content overflowing the container?
    let overflowActive = (contentWidth > availableWidth);
    //let overflowActive = (visualWidth < availableWidth);
    // Return outcome.
    return overflowActive;
}

function toggleEllipsis(id) {
    // Get context.
    let context = getContext(id);
    // Get breakpoint config.
    let breakpoint = getBreakpoint(id);
    // If no breakpoint then default to on.
    if (!breakpoint) {
        context.addClass('ellipsis-text');
    } else {
        if (!Foundation.MediaQuery.is(breakpoint)) {
            context.removeClass('ellipsis-text');
        } else {
            context.addClass('ellipsis-text');
        }
    }
    // Is content overflowing?
    let overflowActive = isOverflowing(id);
    // If overflow active toggle relievent class else remove it.
    if (overflowActive) {
        context.addClass('ellipsis-active');
    } else {
        context.removeClass('ellipsis-active');
    }
}


var ellipsis = $.ellipsis = {
    initialiseAll: () => {
        return initialiseAll();
    },
    initialise: (context) => {
        return initialise(context);
    }
}

export { ellipsis };